import { tns } from "tiny-slider/src/tiny-slider";

$(() => {
  console.log(tns);
  const slider = tns({
    container: '.slider-container',
    items: 1,
    slideBy: 'page',
    mouseDrag: true,
    swipeAngle: false,
    speed: 400,
    gutter: 0,
    arrowKeys: true,
    controls: false,
    responsive: {
      '450': {
        items: 2,
        gutter: 5,
      },
      '900': {
        items: 3,
        gutter: 10,
      },
      '1400': {
        items: 4,
        gutter: 15,
      },
    },
  });
});